<!--  -->
<template>
  <div class="mentee-feedback-title">
    <h1>Fill in feedback</h1>
    <div>
      Feedback submission DDL:{{time| addTwoDay}}
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'mentee-feedback-title',
  components: {},
  props: ['time'],
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {},
  filters: {
    addTwoDay (value) {
      return dayjs(value).add(2, 'day').format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang='less' scoped>
</style>
